import React from 'react'
import ModalComponent from 'components/common/ModalComponent'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { showAlert } from 'services/alerts.service'
import { getFormattedMissingFieldsMessage } from 'utils'

const EditWorkdayModal = ({ isOpen, onClose, workday, onSave }) => {
  const { t } = useTranslation()
  if (!workday) return null

  const handleSave = async (formData) => {
    const htmlMessage = getFormattedMissingFieldsMessage(formData, ['startTime', 'endTime'])
    if (htmlMessage !== '') {
      showAlert({
        html: htmlMessage,
        icon: 'warning'
      })
      return
    }

    onSave(formData)
  }

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={t('mgmt.workdays.editTitle')}
      initialData={{
        workdayId: workday?.workdayId || '',
        workerName: workday?.workerName || '',
        date: workday?.date || '',
        startTime: workday?.startTime || '',
        endTime: workday?.endTime || ''
      }}
      onSave={handleSave}
    >
      {({ formData, handleChange }) => (
        <form className='space-y-4 w-64' autoComplete='off'>
          <div className='text-sm text-gray-700'>
            {formData.workerName}, {formData.date}
          </div>

          <label className='block text-sm font-medium'>
            {t('mgmt.workdays.cols.startTime')} *
            <input
              type='time'
              name='startTime'
              value={formData.startTime}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
              required
            />
          </label>

          <label className='block text-sm font-medium'>
            {t('mgmt.workdays.cols.endTime')} *
            <input
              type='time'
              name='endTime'
              value={formData.endTime}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
              required
            />
          </label>
        </form>
      )}
    </ModalComponent>
  )
}

EditWorkdayModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  workday: PropTypes.object,
  onSave: PropTypes.func.isRequired
}

export default EditWorkdayModal
